import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axiosInstance';
import { toast } from 'sonner';

// ═══════════════════ DASHBOARD ═════════════════════════════════

export const fetchDashboardStats = createAsyncThunk(
  'dashboard/stats',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get('Dashboard/stats');
      return data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchScanTrend = createAsyncThunk(
  'dashboard/scanTrend',
  async (days = 30, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`Dashboard/scan-trend?days=${days}`);
      return data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchClaimTrend = createAsyncThunk(
  'dashboard/claimTrend',
  async (days = 30, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`Dashboard/claim-trend?days=${days}`);
      return data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: { stats: null, scanTrend: [], claimTrend: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchDashboardStats.fulfilled, (s, a) => { s.loading = false; s.stats = a.payload; })
      .addCase(fetchDashboardStats.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      .addCase(fetchScanTrend.fulfilled, (s, a) => { s.scanTrend = a.payload || []; })
      .addCase(fetchClaimTrend.fulfilled, (s, a) => { s.claimTrend = a.payload || []; });
  },
});

export default dashboardSlice.reducer;


// ═══════════════════ NOTIFICATIONS ══════════════════════════════
// (separate file conceptually, inline for brevity)
import { createSlice as cs, createAsyncThunk as cat } from '@reduxjs/toolkit';

export const fetchNotifications = cat(
  'notification/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await api.get('Notifications', { params });
      return data.data;
    } catch (err) { return rejectWithValue(err.message); }
  }
);

export const markNotificationRead = cat(
  'notification/markRead',
  async (id, { rejectWithValue }) => {
    try {
      await api.patch(`Notifications/${id}/read`);
      return id;
    } catch (err) { return rejectWithValue(err.message); }
  }
);

export const markAllRead = cat(
  'notification/markAllRead',
  async (_, { rejectWithValue }) => {
    try {
      await api.patch('Notifications/read-all');
      return true;
    } catch (err) { return rejectWithValue(err.message); }
  }
);